var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#084F8A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7549 26.255H26.9649L26.6849 25.985C27.6649 24.845 28.2549 23.365 28.2549 21.755C28.2549 18.165 25.3449 15.255 21.7549 15.255C18.1649 15.255 15.2549 18.165 15.2549 21.755C15.2549 25.345 18.1649 28.255 21.7549 28.255C23.3649 28.255 24.8449 27.665 25.9849 26.685L26.2549 26.965V27.755L31.2549 32.745L32.7449 31.255L27.7549 26.255ZM21.7549 26.255C19.2649 26.255 17.2549 24.245 17.2549 21.755C17.2549 19.265 19.2649 17.255 21.7549 17.255C24.2449 17.255 26.2549 19.265 26.2549 21.755C26.2549 24.245 24.2449 26.255 21.7549 26.255Z",
    fill: "#027BCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSearch);
export default __webpack_public_path__ + "static/media/healthSearch.cc7f617001dc421a2d8a3d5b608009b8.svg";
export { ForwardRef as ReactComponent };